import React from 'react';

const VIPBuyerModal = ({ isOpen, onClose, onSubscribe }) => {
  const vipBenefits = [
    {
      icon: '⚡',
      title: 'Elsőként értesülsz',
      description: 'Új ingatlanok megjelenése előtt 24 órával'
    },
    {
      icon: '🎯',
      title: 'Exkluzív ajánlatok',
      description: 'Csak VIP tagoknak elérhető ingatlanok'
    },
    {
      icon: '💰',
      title: 'Kedvezmények',
      description: '5-10% kedvezmény kiválasztott ingatlanoknál'
    },
    {
      icon: '🤝',
      title: 'Prioritás kezelés',
      description: 'Gyorsabb válaszidő és személyes támogatás'
    },
    {
      icon: '📊',
      title: 'Piaci elemzések',
      description: 'Havi ingatlanpiaci jelentések és trendek'
    },
    {
      icon: '🎁',
      title: 'Extra szolgáltatások',
      description: 'Ingyenes értékbecslés és jogi tanácsadás'
    }
  ];

  const plans = [
    {
      id: 'monthly',
      title: 'VIP Vevő',
      price: 2990,
      period: '/hó',
      savings: null,
      recommended: true,
      description: 'Előbb látod az új ingatlanokat'
    }
  ];

  const [selectedPlan, setSelectedPlan] = React.useState('quarterly');

  const handleSubscribe = () => {
    const plan = plans.find(p => p.id === selectedPlan);
    onSubscribe(plan);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm">
      <div className="bg-gradient-to-br from-[#1a1a1a] to-[#0a0a0a] rounded-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto border-2 border-yellow-500/30 shadow-2xl">
        {/* Header */}
        <div className="sticky top-0 bg-gradient-to-r from-yellow-500 via-amber-500 to-orange-500 p-6 rounded-t-2xl">
          <div className="flex items-center justify-between">
            <div>
              <div className="flex items-center gap-2 mb-2">
                <span className="text-3xl">👑</span>
                <h2 className="text-2xl md:text-3xl font-black text-white">
                  Ne maradj le a legjobb ingatlanokról!
                </h2>
              </div>
              <p className="text-white/90">
                Légy VIP tag és értesülj előbb az új ajánlatokról
              </p>
            </div>
            <button
              onClick={onClose}
              className="text-white hover:bg-white/20 rounded-full p-2 transition-colors"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="p-6">
          {/* Benefits Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
            {vipBenefits.map((benefit, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-xl rounded-xl p-4 border border-white/[0.08]"
              >
                <div className="flex items-start gap-3">
                  <div className="text-3xl">{benefit.icon}</div>
                  <div>
                    <h4 className="text-white font-bold mb-1">{benefit.title}</h4>
                    <p className="text-gray-300 text-sm">{benefit.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Pricing Plans */}
          <div className="mb-6">
            <h3 className="text-white font-black text-lg mb-4 text-center">💳 Válassz csomagot</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {plans.map((plan) => (
                <div
                  key={plan.id}
                  onClick={() => setSelectedPlan(plan.id)}
                  className={`relative cursor-pointer rounded-2xl p-6 border-2 transition-all duration-300 ${
                    selectedPlan === plan.id
                      ? 'border-yellow-500 scale-105 shadow-2xl shadow-yellow-500/30'
                      : 'border-white/[0.08] hover:border-white/40'
                  } ${plan.recommended ? 'ring-4 ring-yellow-400/50' : ''}`}
                >
                  {/* Recommended Badge */}
                  {plan.recommended && (
                    <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gradient-to-r from-yellow-400 to-amber-500 text-black text-xs font-black px-4 py-1 rounded-full shadow-lg">
                      LEGJOBB AJÁNLAT
                    </div>
                  )}

                  {/* Radio Button */}
                  <div className="absolute top-4 right-4">
                    <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${
                      selectedPlan === plan.id ? 'border-yellow-500 bg-yellow-500' : 'border-white/40'
                    }`}>
                      {selectedPlan === plan.id && (
                        <div className="w-3 h-3 rounded-full bg-white" />
                      )}
                    </div>
                  </div>

                  {/* Plan Content */}
                  <div className="text-center">
                    <div className="text-white font-bold text-lg mb-2">{plan.title}</div>
                    <div className="text-3xl font-black text-white mb-1">
                      {plan.price.toLocaleString()} Ft
                    </div>
                    <div className="text-gray-400 text-sm mb-2">{plan.period}</div>
                    {plan.savings && (
                      <div className="bg-green-500/20 text-green-300 text-xs font-bold px-3 py-1 rounded-full inline-block">
                        {plan.savings}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Stats */}
          <div className="bg-gradient-to-r from-blue-500/20 to-purple-500/20 backdrop-blur-xl rounded-xl p-6 border border-blue-500/30 mb-6">
            <h3 className="text-white font-black text-lg mb-4 text-center">📊 VIP Tagok előnyei számokban</h3>
            <div className="grid grid-cols-3 gap-4 text-center">
              <div>
                <div className="text-3xl font-black text-white mb-1">24h</div>
                <div className="text-gray-300 text-sm">Előny új ingatlanoknál</div>
              </div>
              <div>
                <div className="text-3xl font-black text-white mb-1">5-10%</div>
                <div className="text-gray-300 text-sm">Kedvezmény</div>
              </div>
              <div>
                <div className="text-3xl font-black text-white mb-1">100+</div>
                <div className="text-gray-300 text-sm">Exkluzív ajánlat/hó</div>
              </div>
            </div>
          </div>

          {/* Testimonial */}
          <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-xl rounded-xl p-6 border border-white/[0.08] mb-6">
            <div className="flex gap-1 mb-3">
              {[...Array(5)].map((_, i) => (
                <span key={i} className="text-yellow-400 text-xl">⭐</span>
              ))}
            </div>
            <p className="text-gray-300 italic mb-3">
              "A VIP tagság megérte! 2 nappal korábban láttam az álomházamat, és sikerült megvennem, mielőtt mások is jelentkeztek volna."
            </p>
            <div className="flex items-center gap-3">
              <div className="text-2xl">👨‍💼</div>
              <div>
                <div className="text-white font-bold">Kovács András</div>
                <div className="text-gray-400 text-sm">VIP tag, Budapest</div>
              </div>
            </div>
          </div>

          {/* Actions */}
          <div className="flex gap-4">
            <button
              onClick={onClose}
              className="flex-1 bg-white/10 hover:bg-white/20 text-white font-bold py-4 rounded-xl transition-colors border-2 border-white/[0.08]"
            >
              Kihagyom
            </button>
            <button
              onClick={handleSubscribe}
              className="flex-1 bg-gradient-to-r from-yellow-500 via-amber-500 to-orange-500 hover:from-orange-500 hover:to-yellow-500 text-white font-black py-4 rounded-xl shadow-xl hover:shadow-2xl hover:shadow-yellow-500/50 transition-all"
            >
              Előfizetek most! 👑
            </button>
          </div>

          {/* Money Back Guarantee */}
          <div className="text-center mt-4">
            <p className="text-gray-400 text-sm">
              ✓ Bármikor lemondható • ✓ 30 napos pénzvisszafizetési garancia
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VIPBuyerModal;
